export default __webpack_public_path__ + "static/media/qua1.e52b5a14.jpg";